
// ListarClientes.js

import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';


  const ListarClientes = ({ handleSairListarClick, onCodigoClick }) => {
  const [clientesDaPagina, setClientesDaPagina] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState('nomecli'); // Estado para armazenar a ordenação selecionada
  const [filtroCodCliente, setFiltroCodCliente] = useState(''); // Estado para o código de venda
  const [isFiltrando, setIsFiltrando] = useState(false); // Controle para o filtro

  useEffect(() => {
    fetchClientes(currentPage, orderBy);
  }, [currentPage, orderBy]);


  const fetchClientes = async (page, order = 'nomecli') => {
    try {
      console.log(`Solicitando clientes da página ${page} ordenados por ${order}...`);
      const response = await api.get(`/clientes/listarclientes/paginados?page=${page - 1}&size=10&sortBy=${order}`);

      setClientesDaPagina(response.data.content);
      setTotalPages(response.data.totalPages);
      console.log(`Clientes da página ${page} ordenados por ${order} carregados com sucesso:`, response.data.content);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
    }
  };

const buscarPorCodCliente = async () => {
  try {
    if (filtroCodCliente.trim() === '') {
      alert('Por favor, insira um código de Cliente válido.');
      return;
    }
    
    console.log(`Buscando Cliente por Código: ${filtroCodCliente}`);
    const response = await api.get(`/clientes/buscarclienteporcodigo?codcli=${filtroCodCliente}`);
    
    // Se o cliente foi encontrado (status 200)
    if (response.status === 200) {
      setClientesDaPagina([response.data]); // Coloca o Cliente dentro de um array
      setIsFiltrando(true);
      setTotalPages(1); // Ajustar para evitar paginação em busca
    }
  } catch (error) {
    // Se o status for 404 (Cliente não encontrado)
    if (error.response && error.response.status === 404) {
      alert(`Nenhum Cliente encontrado para o Código: ${filtroCodCliente}`);
      setClientesDaPagina([]); // Limpar a tabela
      setIsFiltrando(false); // Desativa o estado de filtragem
    } else {
      console.error('Erro ao buscar por código do Cliente:', error);
      setClientesDaPagina([]); // Limpar a tabela em caso de outro Erro
      setIsFiltrando(false);
    }
  }
};
  

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  

  const handleOrderByNome = () => {
    setOrderBy('nomecli');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCodigo = () => {
    setOrderBy('codcli');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };


  return (
    <div>
      <Typography variant="h5" gutterBottom>Listagem de Clientes</Typography>

      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <Typography variant="body1" style={{ marginTop: '0px', marginLeft: '20px' }}>
          Página {currentPage} de {totalPages}
        </Typography>

       {/* Botões de Navegação */}
        {!isFiltrando && (
          <Box>
            <ButtonGroup variant="contained" color="primary" style={{ height: '25px', padding: '0px 0px', marginLeft: '20px' }}>
              <Button onClick={handleFirstPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<FirstPageIcon />}></Button>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<NavigateBeforeIcon />}></Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<NavigateNextIcon />}></Button>
              <Button onClick={handleLastPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<LastPageIcon />}></Button>
            </ButtonGroup>
          </Box>
        )}

      </Box>      


<Box display="flex" justifyContent="center" alignItems="center" mt={0}>
  {/* Botões de Ordenação e Busca */}
  <Box display="flex" justifyContent="center" alignItems="center" gap={2}>

    {/* Botões de Ordenação */}
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCodigo}
    >
      Por Código
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        marginLeft: '25px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByNome}
    >
      Por Cliente
    </Button>
         
    {/* Campo de Busca */}
    <input
      type="text"
      placeholder="Código"
      value={filtroCodCliente}
      onChange={(e) => setFiltroCodCliente(e.target.value)}
      style={{
        padding: '5px',
        width: '60px',
        marginLeft: '30px',
        height: '25px',
        fontSize: '14px'
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={buscarPorCodCliente}
      style={{
        height: '25px',
        marginLeft: '20px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
    >
      Buscar
    </Button>          
          
    {/* Botão de Fechar à Direita */}
     <button
        type="button"
        className="btn-menu"
        onClick={handleSairListarClick}
        style={{ fontSize: '12px', fontWeight: 'bold', 
          height: '25px', padding: '3px 6px', marginLeft: '30px', width: '80px', color: 'inherit' }}
      >
        Fechar
      </button>
        
        </Box>
      </Box>

<div style={{ overflowX: 'auto', margin: '20px' }}>
  <table
    style={{
      textAlign: 'left',
      borderCollapse: 'collapse',
      width: '100%',
      minWidth: '800px', // Define uma largura mínima para a tabela
    }}
  >
    <thead>
      <tr>
        <th style={{ padding: '10px', width: '80px' }}>Código</th>
        <th style={{ padding: '10px', width: '200px' }}>Nome</th>
        <th style={{ padding: '10px', width: '150px' }}>Fone</th>
        <th style={{ padding: '10px', width: '150px' }}>Celular</th>
        <th style={{ padding: '10px', width: '250px' }}>Email</th>
        <th style={{ padding: '10px', width: '200px' }}>CNPJ</th>
      </tr>
    </thead>
    <tbody>
      {clientesDaPagina.map((cliente) => (
        <tr key={cliente.id}>
          <td
            style={{
              padding: '10px',
              cursor: 'pointer',
              color: 'blue',
              textAlign: 'center',
            }}
            onClick={() => onCodigoClick(cliente.codcli)}
          >
            {cliente.codcli}
          </td>
          <td style={{ padding: '10px' }} translate="no">{cliente.nomecli}</td>
          <td style={{ padding: '10px' }}>{cliente.fone}</td>
          <td style={{ padding: '10px' }}>{cliente.celular}</td>
          <td style={{ padding: '10px' }}>{cliente.email}</td>
          <td style={{ padding: '10px' }}>{cliente.cnpjcli}</td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

  </div>
  );
};

export default ListarClientes;